import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faList } from '@fortawesome/free-solid-svg-icons';
import './Total.css';

const Total = ({ count = 0 }) => {
    return (
        <div className="total-card">
            <div className="total-header">
                <span className="total-title">Total Items</span>
                <FontAwesomeIcon icon={faList} className="total-icon" />
            </div>
            <span className="total-count">{count}</span>
        </div>
    );
};

export default Total;
